import { render } from "./RuiStar.vue?vue&type=template&id=5192257b"
const script = {}
script.render = render

export default script